// history package is provided by react-router-dom as nested dependency, eslint does not detect that
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';

export const browserHistory = createBrowserHistory({ window });
